var render = function render(_c,_vm){return _c('b-col',{staticClass:"one-cart-wishlist-options-container justify-content-between"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }